import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { App } from './App';
import { LoginPage } from './features/auth/LoginPage';
import { ChatPage } from './features/chat/ChatPage';
import { OnboardingPage } from './features/onboarding/OnboardingPage';
import { PartnersPage } from './features/partners/PartnersPage';
import { PartnerProfilePage } from './features/partners/PartnerProfilePage';
import { BriefingPage } from './features/briefing/BriefingPage';
import { CoachPage } from './features/coach/CoachPage';
import { SpeechCoachPage } from './features/coach/SpeechCoachPage';
import { JournalPage } from './features/journal/JournalPage';
import { NavigatorPage } from './features/navigator/NavigatorPage';
import { isAuthenticated } from './lib/auth';

function RequireAuth() {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/chat" replace /> },
      { path: 'login', element: <LoginPage /> },
      {
        element: <RequireAuth />,
        children: [
          { path: 'chat', element: <ChatPage /> },
          { path: 'onboarding', element: <OnboardingPage /> },
          { path: 'partners', element: <PartnersPage /> },
          { path: 'partners/:id', element: <PartnerProfilePage /> },
          { path: 'briefing/:eventId', element: <BriefingPage /> },
          { path: 'coach', element: <CoachPage /> },
          { path: 'coach/speech', element: <SpeechCoachPage /> },
          { path: 'journal', element: <JournalPage /> },
          { path: 'navigator', element: <NavigatorPage /> },
        ],
      },
      { path: '*', element: <Navigate to="/chat" replace /> },
    ],
  },
]);
